import './lib/setup'

import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

// Register the app with contexts applied
ReactDOM.render( <App />, document.getElementById( 'root' ) )
